import { State, create } from 'zustand';

// @ts-ignore
interface StoreState extends State {
  isLoading: boolean;
  message: string;
  setIsLoading: (isLoading: boolean, message: string | null) => void;
}

const useStore = create<StoreState>((set) => ({
  isLoading: false,
  message: 'Carregando...',
  setIsLoading: (isLoading, message) =>
    set({ isLoading, message: message || 'Carregando...' }),
}));

const useLoadingActions = () => {
  const { isLoading, message, setIsLoading } = useStore();

  return { isLoading, message, setIsLoading };
};

export default useLoadingActions;
